import React from 'react';
import './Lets_connect.css'; // Import the CSS file

const Lets_connect = () => {
  return (
    
    <div className="lets-connect-container">
      <div className="contact-info">
        <p className="subtitle">Contact Us</p>
        <h2>Get in Touch</h2>
        <p className="description">
          Draftsman has highly qualified professionals and upgraded software.
          We design architectural drawings for various buildings with vastu
          shastra. Our designs are latest with innovative ideas.
        </p>

        <div className="contact-details">
          <div><span className="icon">📞</span>+ (231) 770-508-020 <br/>+ (91)9908526058</div>
          <div><span className="icon">📧</span>blessedandblessed247@gmail.com</div>
          <div><span className="icon">⏰</span>Open Hours 09:00 am - 05:00 pm</div>
          <div><span className="icon">📍</span>Jacob Town, Greater Monrovia, Montserrado County, Liberia.</div>
        </div>

       <div className="social-media">
  <p>Follow on:</p>
  <div className="social-icons">
    <a href="https://www.facebook.com/share/14EBxsG3Lot/" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-facebook-f"></i>
    </a>
    <a href="https://wa.me/231770508020" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-whatsapp"></i>
    </a>
    <a href="https://www.instagram.com/jbc.design.studio.2030/?igsh=MWhha2xrM3B4OHZqZQ%3D%3D" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-instagram"></i>
    </a>
    <a href="https://www.youtube.com/channel/UCkyWYqpxs8blS_FCtC9f4Wg" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-youtube"></i>
    </a>
    <a href="https://www.linkedin.com/in/johnson-cole-736686248/" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-linkedin"></i>
    </a>
    <a href="https://www.pinterest.com/JBCDESIGNSTUDIO/jbc-portfolio/" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-pinterest-p"></i>
    </a>
  </div>
</div>

      </div>

      <div className="map-container">
  <iframe
    title="Jacob Town, Liberia Location"
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15888.473158338787!2d-10.7123!3d6.2923!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc000a3b4efed1e%3A0x4a2a7c21c67b0a11!2sJacob%20Town%2C%20Liberia!5e0!3m2!1sen!2slr!4v1717937483000!5m2!1sen!2slr"
    width="100%"
    height="300"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>
    </div>
  );
};

export default Lets_connect;
